<template>
    <div class="mask_box">
        <i class="el-icon-loading" style="font-size: 32px;"></i>
    </div>
</template>

<script>
    export default {
        name:"maskLoading",
        data() {
            return {

            }
        },
        // 控制页面滚动
        beforeCreate() {
            document.body.setAttribute("class","loading-hidden")
        },
        beforeDestroy() {
            document.body.removeAttribute("class")
        }
    }
</script>

<style lang="less" scoped>
    .mask_box{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        background-color: #fff;
        z-index: 99;
    }
    
</style>